<template>
  <div>
    <!-- 修改 -->
    <creat-rule
      v-if="pageType === 'companySettings'"
      class="rule"
      @back="pageType = ''"
    ></creat-rule>
    <!-- 企业信息 -->
    <div v-else>
      <div ref="searchBox" class="layout-header">
        <div>
          <div class="title">
            测评设置
            <p class="float-r">
              <el-button size="small" @click="editCategorys"
                >分类设置
              </el-button>
              <el-button type="primary" size="small" @click="onAdd"
                >编辑规则</el-button
              >
            </p>
          </div>
          <el-tabs v-model="activeName" @tab-click="changeDate">
            <el-tab-pane label="当月执行" name="1">
              <span style="font-size: 14px">启用自动化考核状态：</span>
              <el-select multiple collapse-tags clearable v-model="selectValue" placeholder="请选择" @change="handleSelect">
                <div style="padding: 0 20px;line-height:34px">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="optionsAll" @change="handleCheckAllChange">全选</el-checkbox>
                </div>
                <el-checkbox-group v-model="selectValue">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    <el-checkbox style="pointer-events: none" :label="item.value">{{ item.label }}</el-checkbox>
                  </el-option>
                </el-checkbox-group>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="历史规则" name="2">
              选择月份：
              <el-date-picker
                v-model="date"
                type="month"
                align="right"
                unlink-panels
                size="small"
                @change="changeDate"
              ></el-date-picker>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div :style="{ height: height }"></div>
      <div class="pagination-bg-white layout-header">
        <w-table
          :height="tableViewHeight"
          width="100%"
          v-loading.body="tableLoading"
          :data-list="tableData"
          :columns="staticData.rate"
          :pageNo="formData.pageNum"
          :pageSize="formData.pageSize"
          :total="total"
          :objectSpanMethod="objectSpanMethod"
          :bPagination="false"
        >
          <template slot-scope="{ row }" slot="isin">
            <el-switch
             @change='changeRule2($event,row)'
              size="mini"
              v-model="row.isIn"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </template>
          <template slot-scope="{ text }" slot="cell">
            <span>{{ text }}</span>
          </template>
        </w-table>
        <!-- <div>您的账户没有权限查看此内容！</div> -->
      </div>
    </div>
    <!-- 分类设置 -->
    <categoryEdit :visible.sync="categoryDialog"></categoryEdit>
  </div>
</template>

<script>
import Api from '@/api'
import WTable from '@/components/Table/index.vue'
import staticData from './staticData.js'
import categoryEdit from './components/category_edit.vue'
import creatRule from './components/rule.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'setting',
  components: {
    WTable,
    categoryEdit,
    creatRule
  },
  data() {
    return {
      height: '156px',
      date: new Date(),
      loading: false,
      pageType: '',
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 1,
      tableLoading: false,
      tableData: null,
      type: 'add',
      detail: null,
      searchData: null,
      tableViewHeight: '',
      categoryDialog: false,
      activeName: '1',
      form: {},
      options: [
        {
          value: 1,
          label: '站外还车考核启用'
        }, {
          value: 2,
          label: '站外还车异常终止'
        }, {
          value: 3,
          label: '非法车辆考核启用'
        }, {
          value: 4,
          label: '非法车辆异常终止'
        }, {
          value: 5,
          label: '重点区域考核启用'
        }, {
          value: 6,
          label: '重点区域异常终止'
        }, {
          value: 7,
          label: '普通区域考核启用'
        }, {
          value: 8,
          label: '普通区域考核终止'
        }],
      selectValue: [],
      optionsAll: false,
      isIndeterminate: true
    }
  },
  computed: {
    ...mapGetters(['selfAreaId']),
    staticData() {
      return staticData
    }
  },
  created() {
    this.initData()
    this.calcView()
  },
  methods: {
    changeDate() {
      this.initData()
      this.calcView()
    },
    changeRule(row) {
      if (row) {
        this.publicChangeRuleTwo(row)
      } else {
        this.publicChangeRule()
      }
       Api.setFixedRuleConf(this.selfAreaId, this.form).then(({ data }) => {
        console.log(data)
        this.initData()
      })
    },
    changeRule2(isIn, row) {
      console.log(isIn, row)
      if (row.key) {
        this.form[row.key] = isIn
        this.changeRule(row)
      } else {
        Api.setTrendsRuleAssess(this.selfAreaId, { id: row.examineId, isIn }).then(({ data }) => {
          console.log(data)
        })
      }
    },
    initData() {
      this.tableLoading = true
      const time = this.activeName == '2' ? this.date : new Date()
      const params = {
        selfAreaId: this.selfAreaId,
        workDate: this.dayjs(time).format('YYYYMM')
      }
      Api.getRuleList(params).then(({ data }) => {
        this.tableData = data.category
        this.form = {}
        if (data.fixed) {
          this.form = {
            workDate: this.dayjs(time).format('YYYYMM'),
            // 站外还车
            enable: data.fixed.enable ? 1 : 0,
            abortTerminateSwitch: data.fixed.abortTerminateSwitch ? 1 : 0,
            dispatchAssessSwitch: data.fixed.dispatchAssessSwitch ? 1 : 0,
            // 非法车辆
            legalityEnable: data.fixed.legalityEnable ? 1 : 0,
            legalityAbortTerminate: data.fixed.legalityAbortTerminate ? 1 : 0,
            legalityDispatchAssess: data.fixed.legalityDispatchAssess ? 1 : 0,
            // 重点区域
            importantEnable: data.fixed.importantEnable ? 1 : 0,
            importantAbortTerminate: data.fixed.importantAbortTerminate ? 1 : 0,
            importantDispatchAssess: data.fixed.importantDispatchAssess ? 1 : 0,
            // 普通区域
            commonEnable: data.fixed.commonEnable ? 1 : 0,
            commonAbortTerminate: data.fixed.commonAbortTerminate ? 1 : 0,
            commonDispatchAssess: data.fixed.commonDispatchAssess ? 1 : 0,

            exceedAssessSwitch: data.fixed.exceedAssessSwitch ? 1 : 0,
            finishAssessSwitch: data.fixed.finishAssessSwitch ? 1 : 0
          }
          // 回显下拉框数据
          this.handleSelectData(data.fixed)
          this.tableData.unshift(
            {
              categoryName: '日常运营管理类',
              categoryName2: '配额总量管控',
              ruleName: '是否超额投放',
              description: data.fixed.exceedDescribe,
              key: 'exceedAssessSwitch',
              isIn: data.fixed.exceedAssessSwitch ? 1 : 0
            },
            {
              categoryName: '日常运营管理类',
              categoryName2: '调度指令处置要求',
              ruleName: '站外还车处置及时率',
              key: 'dispatchAssessSwitch',
              description: data.fixed.outsideDescribe,
              isIn: data.fixed.dispatchAssessSwitch ? 1 : 0
            },
            {
              categoryName: '日常运营管理类',
              categoryName2: '调度指令处置要求',
              ruleName: '非法车辆处置及时率',
              key: 'legalityDispatchAssess',
              description: data.fixed.legalityDescribe,
              isIn: data.fixed.legalityDispatchAssess ? 1 : 0
            },
            {
              categoryName: '日常运营管理类',
              categoryName2: '调度指令处置要求',
              ruleName: '重点偏多处置及时率',
              key: 'importantDispatchAssess',
              description: data.fixed.importantDescribe,
              isIn: data.fixed.importantDispatchAssess ? 1 : 0
            },
            {
              categoryName: '日常运营管理类',
              categoryName2: '调度指令处置要求',
              ruleName: '普通偏多处置及时率',
              key: 'commonDispatchAssess',
              description: data.fixed.dispatchDescribe,
              isIn: data.fixed.commonDispatchAssess ? 1 : 0
            },
            {
              categoryName: '日常运营管理类',
              categoryName2: '调度指令处置要求',
              ruleName: '处置完结情况',
              key: 'finishAssessSwitch',
              description: data.fixed.finishDescribe,
              isIn: data.fixed.finishAssessSwitch ? 1 : 0
            }
          )
        }

        this.tableData = this.mergeTableRow(this.tableData, [
          'categoryName',
          'categoryName2'
        ])
        this.tableLoading = false
        //
      })
    },
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        this.height = H + 10 + 'px'
        // 56: 导航栏高度修正 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    },
    onAdd() {
      this.type = 'add'
      this.pageType = 'companySettings'
    },
    editCategorys() {
      this.categoryDialog = true
    },
    handleCloseEdit() {
      this.pageType = ''
      this.detail = null
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const span = column.property + '-span'
      if (row[span]) {
        return row[span]
      }
    },
    mergeTableRow(data, merge) {
      if (!merge || merge.length === 0) {
        return data
      }
      merge.forEach((m) => {
        const mList = {}
        data = data.map((v, index) => {
          const rowVal = v[m]
          if (mList[rowVal] && mList[rowVal].newIndex === index) {
            mList[rowVal].num++
            mList[rowVal].newIndex++
            data[mList[rowVal].index][m + '-span'].rowspan++
            v[m + '-span'] = {
              rowspan: 0,
              colspan: 0
            }
          } else {
            mList[rowVal] = { num: 1, index: index, newIndex: index + 1 }
            v[m + '-span'] = {
              rowspan: 1,
              colspan: 1
            }
          }
          return v
        })
      })
      return data
    },
    // 复选框全选
    handleCheckAllChange(isChecked) {
      const data = this.options.map(item => {
        return item.value
      })
      this.selectValue = isChecked ? data : []
      if (isChecked) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    // 下拉框选择事件
    handleSelect(value) {
      const checkedCount = value.length
      if (checkedCount > 0 && checkedCount === this.options.length) {
        this.isIndeterminate = false
        this.optionsAll = true
      } else {
        this.isIndeterminate = true
      }
      // 下拉框点击时修改点击值
      this.$nextTick(() => {
        setTimeout(() => {
          this.changeRule()
        }, 500)
      })
    },
    // 封装下拉框选项数值
    handleSelectData(data) {
      this.selectValue = []
      const enable = data.enable ? 1 : null
      const abortTerminateSwitch = data.abortTerminateSwitch ? 2 : null
      const legalityEnable = data.legalityEnable ? 3 : null
      const legalityAbortTerminate = data.legalityAbortTerminate ? 4 : null
      const importantEnable = data.importantEnable ? 5 : null
      const importantAbortTerminate = data.importantAbortTerminate ? 6 : null
      const commonEnable = data.commonEnable ? 7 : null
      const commonAbortTerminate = data.commonAbortTerminate ? 8 : null
      const SelectData = []
      SelectData.push(enable, abortTerminateSwitch, legalityEnable, legalityAbortTerminate,
        importantEnable, importantAbortTerminate, commonEnable, commonAbortTerminate)
      // 去除数值为null的数据
      SelectData.map(item => {
        if (item !== null) {
          this.selectValue.push(item)
        }
      })
      console.log(this.selectValue, 'selectValue')
    },
    publicChangeRuleTwo(row) {
      if (row.ruleName === '是否超额投放') {
        this.form.exceedAssessSwitch = row.isIn
      } else if (row.ruleName === '站外还车处置及时率') {
        this.form.dispatchAssessSwitch = row.isIn
        this.form.enable = this.selectValue.includes(1) ? 1 : null
        this.form.abortTerminateSwitch = this.selectValue.includes(2) ? 1 : null
      } else if (row.ruleName === '非法车辆处置及时率') {
        this.form.legalityDispatchAssess = row.isIn
        this.form.legalityEnable = this.selectValue.includes(3) ? 1 : null
        this.form.legalityAbortTerminate = this.selectValue.includes(4) ? 1 : null
      } else if (row.ruleName === '重点偏多处置及时率') {
        this.form.importantDispatchAssess = row.isIn
        this.form.importantEnable = this.selectValue.includes(5) ? 1 : null
        this.form.importantAbortTerminate = this.selectValue.includes(6) ? 1 : null
      } else if (row.ruleName === '普通偏多处置及时率') {
        this.form.commonDispatchAssess = row.isIn
        this.form.commonEnable = this.selectValue.includes(7) ? 1 : null
        this.form.commonAbortTerminate = this.selectValue.includes(8) ? 1 : null
      } else { // 处置完结情况
        this.form.finishAssessSwitch = row.isIn
      }
    },
    publicChangeRule() {
      // 站外还车
      this.form.enable = this.selectValue.includes(1) ? 1 : null
      this.form.abortTerminateSwitch = this.selectValue.includes(2) ? 1 : null
      // 非法车辆
      this.form.legalityEnable = this.selectValue.includes(3) ? 1 : null
      this.form.legalityAbortTerminate = this.selectValue.includes(4) ? 1 : null
      // 重点区域
      this.form.importantEnable = this.selectValue.includes(5) ? 1 : null
      this.form.importantAbortTerminate = this.selectValue.includes(6) ? 1 : null
      // 普通区域
      this.form.commonEnable = this.selectValue.includes(7) ? 1 : null
      this.form.commonAbortTerminate = this.selectValue.includes(8) ? 1 : null
    }
  }
}
</script>

<style lang="less" scoped>
.infor-layout-header {
  align-items: flex-start;
}
.title {
  font-size: 20px;
  font-weight: 500;
  color: #111111;
  line-height: 24px;
}
.layout-header {
  margin: 16px;
  width: calc(100% - 80px);
}

.float-r {
  float: right;
}

.flex {
  display: flex;
  align-items: center;
}

.system-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
}

.rule {
  margin-left: 0;
  z-index: 11;
  padding-bottom: 60px;
  height: 100%;
}
::v-deep.multipleSty .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
</style>
